/* eslint-disable no-unused-vars */
import { useToast } from 'vue-toastification'

import {
  getAllVouchers,
  getVoucherHistoric,
  allocateVoucher
} from '../services/index'

const toast = useToast()

export default {
  namespaced: true,
  state: () => ({
    icon: require('@/assets/icons/icon-voucher.svg'),
    vouchers: [],
    loadingVouchers: false,
    totalPages: null,
    totalContent: null,
    page: 1,
    industry: null,
    contract: null,
    consultantDoctor: null,
    status: null,
    voucherHistory: null,
    agent: null,
    totalVoucherAavailable: 0,
    totalVouchers: 0,
    sortOrder: 'ASC'
  }),
  mutations: {
    setVouchers(state, vouchers) {
      state.vouchers = vouchers
    },
    setVoucherHistory(state, voucherHistory) {
      state.voucherHistory = voucherHistory
    },
    setLoadingVouchers(state, value) {
      state.loadingVouchers = value
    },
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages
    },
    setTotalContent(state, totalContent) {
      state.totalContent = totalContent
    },
    setPage(state, page) {
      state.page = page
    },
    setIndustry(state, industry) {
      state.industry = !industry ? null : industry
    },
    setContract(state, contract) {
      state.contract = !contract ? null : contract
    },
    setConsultantDoctor(state, consultantDoctor) {
      state.consultantDoctor = !consultantDoctor ? null : consultantDoctor
    },
    setConsultantAgent(state, agent) {
      state.agent = !agent ? null : agent
    },
    setStatus(state, status) {
      state.status = !status ? null : status
    },
    setSortOrder(state, sortOrder) {
      state.sortOrder = !sortOrder ? 'ASC' : sortOrder
    },
    setTotalVoucherAavailable(state, totalVoucherAavailable) {
      state.totalVoucherAavailable = totalVoucherAavailable
    },
    setTotalVoucher(state, totalVouchers) {
      state.totalVouchers = !totalVouchers ? null : totalVouchers
    }
  },
  actions: {
    async fetchAllVouchersForExport({ commit, state }) {
      commit('setLoadingVouchers', true)
      let allData = []
      let currentPage = 1
      let hasMorePages = true

      try {
        while (hasMorePages) {
          const params = {
            page: currentPage,
            size: 100, // Um tamanho razoável por página
            sortOrder: state.sortOrder || 'ASC',
            ...(state.contract && { contractId: state.contract }),
            ...(state.industry && { industryId: state.industry }),
            ...(state.consultantDoctor && {
              consultantDoctorId: state.consultantDoctor
            }),
            ...(state.status && { status: state.status }),
            ...(state.agent && { agentId: state.agent })
          }

          const response = await getAllVouchers(params)
          const { content, totalPages } = response.data

          // Adiciona os resultados desta página ao array final
          allData = [...allData, ...content]

          // Verifica se há mais páginas
          hasMorePages = currentPage < totalPages
          currentPage++
        }

        return allData
      } catch (error) {
        toast.warning('Não foi possível exportar os vouchers', {
          timeout: 8000
        })
        throw error
      } finally {
        commit('setLoadingVouchers', false)
      }
    },
    async fetchVoucherAll({ commit, state }, params = {}) {
      commit('setLoadingVouchers', true)
      const defaultParams = {
        page: state.page,
        contractId: state.contract,
        industryId: state.industry,
        consultantDoctorId: state.consultantDoctor,
        status: state.status,
        agentId: state.agent,
        sortOrder: state.sortOrder || 'ASC',
        ...params // Merge params passed to the action
      }

      return getAllVouchers(defaultParams)
        .then((response) => {
          commit('setVouchers', response.data.content)
          commit('setTotalPages', response.data.totalPages)
          commit('setTotalContent', response.data.totalContent)
          commit(
            'setTotalVoucherAavailable',
            response.data.totalVoucherAavailable
          )
          commit('setTotalVoucher', response.data.totalVouchers)
          return response.data
        })
        .catch((error) => {
          toast.warning('Não foi possível buscar os vouchers', {
            timeout: 8000
          })
          throw error
        })
        .finally(() => {
          commit('setLoadingVouchers', false)
        })
    },
    async allocateVoucherForDoctor({ commit }, { contractId, clientDoctorId }) {
      try {
        const response = await allocateVoucher({ contractId, clientDoctorId })
        toast.success('Voucher alocado com sucesso')
        return response.data
      } catch (error) {
        console.error('Erro ao alocar voucher:', error)
        toast.error('Não foi possível alocar o voucher')
        throw error
      }
    },
    updatePage({ commit }, page) {
      commit('setPage', page)
    },
    setIndustryId({ commit }, industry) {
      commit('setIndustry', industry)
    },
    setContractId({ commit }, contract) {
      commit('setContract', contract)
    },
    setConsultantDoctorId({ commit }, consultantDoctor) {
      commit('setConsultantDoctor', consultantDoctor)
    },
    setConsultantAgentId({ commit }, agent) {
      commit('setConsultantAgent', agent)
    },
    setStatusId({ commit }, status) {
      commit('setStatus', status)
    },
    setDateSortOrder({ commit }, dateSort) {
      commit('setSortOrder', dateSort)
    },
    async fetchVoucherHistory({ commit }, voucherId) {
      commit('setLoadingVouchers', true)

      return getVoucherHistoric(voucherId)
        .then((response) => {
          commit('setVoucherHistory', response.data)
          return response.data
        })
        .catch((error) => {
          toast.warning('Não foi possível buscar o histórico do voucher', {
            timeout: 8000
          })
          throw error
        })
        .finally(() => {
          commit('setLoadingVouchers', false)
        })
    }
  },
  getters: {
    getIcon: (state) => state.icon,
    getVouchers: (state) =>
      state.vouchers.sort((a, b) => {
        if (state.sortOrder === 'ASC') {
          return new Date(a.updatedAt) - new Date(b.updatedAt)
        } else {
          return new Date(b.updatedAt) - new Date(a.updatedAt)
        }
      }),
    getLoadingVouchers: (state) => state.loadingVouchers,
    getTotalPages: (state) => state.totalPages,
    getTotalContent: (state) => state.totalContent,
    getPage: (state) => state.page,
    getIndustry: (state) => state.industry,
    getContractVoucher: (state) => state.contract,
    getConsultantDoctor: (state) => state.consultantDoctor,
    getStatus: (state) => state.status,
    getVoucherHistory: (state) => state.voucherHistory,
    getAgent: (state) => state.agent,
    getTotalVoucherAavailable: (state) => state.totalVoucherAavailable,
    getTotalVoucher: (state) => state.totalVouchers
  }
}
